import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { SoggettoPratica } from '../../../../common/models/tipologiche/soggetto-pratica';
import { TipoTipologica } from "../../../../common/models/tipologiche/tipo-tipologica";

export class FascicoloAltrerisoluzionilavoro extends FascicoloFull {
  dataApertura: number;
  societa: SoggettoPratica;
  risoluzioneRapportoDiLavoro: boolean;
  dataRisoluzioneRapportoDiLavoro: number;
  tipoRisoluzione: TipoTipologica;
  constructor() {
    super();
    this.dataApertura = + new Date();
    this.dataInizioFascicolo = + new Date();
  }
}
